import { FC, memo, useCallback } from 'react';
import { ListControl } from 'shared/ui/list-control';
import {
  BroadcastModerationBlockStyled,
  BroadcastModerationGridStyled,
  BroadcastModerationLabelStyled,
  BroadcastModerationStyled,
} from './broadcast-moderation.styles';
import { IBroadcastModerationProps } from './broadcast-moderation.types';

export const BroadcastModeration: FC<IBroadcastModerationProps> = memo(
  ({ selected, items, title, togglerType, onChange }) => {
    const handleToggle = useCallback(
      (id: number) => {
        if (selected.includes(id)) {
          onChange(selected.filter(el => el !== id));
        } else {
          onChange([...selected, id]);
        }
      },
      [onChange, selected],
    );

    return (
      <BroadcastModerationStyled>
        <BroadcastModerationBlockStyled>
          {title && (
            <BroadcastModerationLabelStyled>
              {title}
            </BroadcastModerationLabelStyled>
          )}

          <BroadcastModerationGridStyled>
            {items.map(item => (
              <ListControl
                togglerType={togglerType}
                checked={selected.includes(item.id)}
                onCheck={() => handleToggle(item.id)}
                key={item.id}
              >
                {item.name}
              </ListControl>
            ))}
          </BroadcastModerationGridStyled>
        </BroadcastModerationBlockStyled>
      </BroadcastModerationStyled>
    );
  },
);
